import React, { useRef } from "react"
import { closeOverlay, useOverlayDispatch, useOverlayState } from "../../context/overlay"

import OverlayStyles from "./overlay.module.css"
import classNames from "classnames"
import { useOnClickOutside } from "../../hooks/use-on-click-outside"

const Overlay = () => {
    const overlayRef = useRef(null)

    const { showOverlay, content, header, isVideo, disableOnClickOutside, disableClose, zIndex } = useOverlayState()
    const dispatch = useOverlayDispatch()

    useOnClickOutside(
        () => !disableOnClickOutside && showOverlay && closeOverlay(dispatch),
        [overlayRef],
        [showOverlay]
    )

    return (
        <div className={OverlayStyles.container} style={{ display: !showOverlay ? "none" : undefined, zIndex: zIndex }}>
            <div
                className={classNames({
                    [OverlayStyles.overlay]: !isVideo,
                    [OverlayStyles.videoOverlay]: isVideo,
                })}
                ref={overlayRef}
            >
                {showOverlay && (
                    <>
                        {header && (
                            <div className={OverlayStyles.header}>
                                <div>{header}</div>
                            </div>
                        )}
                        {!disableClose && (
                            <button
                                className={OverlayStyles.close}
                                type="button"
                                onClick={() => closeOverlay(dispatch)}
                            >
                                <i className="lavita-icon"></i>
                            </button>
                        )}
                        <div className={classNames({ [OverlayStyles.content]: !isVideo })}>{content}</div>
                    </>
                )}
            </div>
        </div>
    )
}

export default Overlay
